import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { slideDown } from '../../animations/animations';

export type AlertType = 'success' | 'info' | 'warning' | 'danger';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideDown],
})
export class AlertComponent {
  /** Message body text */
  @Input() message: string;

  /** Title text */
  @Input() title?: string;

  /** Type of alert (success, info, warning, danger) */
  @HostBinding('class') @Input() type?: AlertType = 'danger';
  @HostBinding('class.mobile') @Input() mobile?: boolean = false;
  @HostBinding('@slideDown') get slideAnimation(): string {
    return '';
  }
}
